import { render, staticRenderFns } from "./EditCodDeposits.vue?vue&type=template&id=3ff39718&scoped=true&"
import script from "./EditCodDeposits.vue?vue&type=script&lang=js&"
export * from "./EditCodDeposits.vue?vue&type=script&lang=js&"
import style0 from "./EditCodDeposits.vue?vue&type=style&index=0&id=3ff39718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff39718",
  null
  
)

export default component.exports